import jstz from 'jstz';
import moment from 'moment';
import 'moment-timezone';

function TimezoneService() {
  this.determine = function () {
    const tz = jstz.determine();
    return tz ? tz.name() : null;
  };

  this.list = function () {
    const timezones = moment.tz.names();

    return timezones;
  };
}

TimezoneService.$inject = [];

export default TimezoneService;



// WEBPACK FOOTER //
// ./src/services/timezoneService.js